import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card";
import { Icon } from "@iconify-icon/solid";
import { LoadingButton } from "../../components/ui/Button";
import { AppointmentActionDropdown } from "../appointment/actions";
import { TextAreaInput } from "../../components/ui/form/TextAreaInput";
import { TextInput } from "../../components/ui/form/TextInput";
import useCheckupCase from "../../services/checkup/useCheckupCase";
import { Show, createEffect } from "solid-js";

export default function CheckupCase(props) {
  const { caseForm, onSaveCase, handleCaseInput } = useCheckupCase(props);

  // Register save function with parent component
  if (props.onRegisterSave) {
    props.onRegisterSave(onSaveCase);
  }

  // Track form changes - compare with original case data
  createEffect(() => {
    if (props.onFormChange) {
      const originalTitle = props.case?.title || "";
      const originalNotes = props.case?.notes || "";
      const currentTitle = caseForm.title || "";
      const currentNotes = caseForm.notes || "";
      const hasChanges = originalTitle !== currentTitle || originalNotes !== currentNotes;
      props.onFormChange(hasChanges);
    }
  });

  return (
    <Card>
      <CardHeader class="pt-6 pb-3">
        <CardTitle class="flex items-center gap-2 justify-between">
          <div class="flex items-center">
            <Icon icon="mdi:stethoscope" class="text-gray-500 me-2" />
            Current Case
          </div>
          <div>
            <AppointmentActionDropdown
              onAction={props.onAction}
              key={props.appointment.key}
              status={props.appointment.status}
              doctorId={props.appointment.doctorId}
            />
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent class="space-y-4 pt-0">
        {/* Patient Information */}
        <div class="space-y-3 pt-0">
          <div class="space-y-2">
            <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
              Patient Name
            </label>
            <p class="text-lg font-semibold">{props.appointment.patient}</p>
          </div>

          <Show when={props.appointment.phone}>
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Phone
              </label>
              <p class="text-lg">{props.appointment.phone}</p>
            </div>
          </Show>

          <Show when={props.appointment.email}>
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Email
              </label>
              <p class="text-lg">{props.appointment.email}</p>
            </div>
          </Show>

          <Show when={props.appointment.case_start_date}>
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Case Start Date
              </label>
              <p class="text-lg">{props.appointment.case_start_date}</p>
            </div>
          </Show>
        </div>

        <div>
          <TextInput
            label="Title"
            name="title"
            form={caseForm}
            input={handleCaseInput}
            placeholder="Enter case title..."
          />
        </div>

        <div>
          <TextAreaInput
            label="Notes"
            name="notes"
            form={caseForm}
            input={handleCaseInput}
            rows={10}
            placeholder="Enter case notes..."
          />
        </div>

        {/* Update Case */}
        <Show when={!props.hideSaveButton}>
          <div class="border-t pt-4">
            <LoadingButton
              loading={props.loading}
              onClick={onSaveCase}
              class="w-full"
              disabled={!caseForm.title}
            >
              Update Case
            </LoadingButton>
          </div>
        </Show>
      </CardContent>
    </Card>
  );
}
